import { cls } from "../components/Utility";
import a1 from "../assets/pictures/about/about_111.webp";
import a2 from "../assets/pictures/about/about_222.webp";
import a3 from "../assets/pictures/about/about_333.webp";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <>
      <div className="w-full bg-[#f8f8f6] pb-[105px]"></div>
      <p
        className={cls(
          "text-center font-[Headings] font-extrabold text-[25px] pl-[20px] pr-[20px] mt-[20px]",
          "xl:text-[35px] xl:pl-[380px] xl:pr-[380px]"
        )}
      >
        OUR COMPANY
      </p>
      <p
        className={cls(
          "mt-[20px] text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
          "xl:pl-[380px] xl:pr-[380px]"
        )}
      >
        We, at Stories by RG, are bound by the principle of innovation with
        excellence in the wedding industry. We craft each and every photograph
        with a precious touch to capture the ravishing essence of the beautiful
        couple's big day. We capture every moment of yours through our magical
        lens to preserve your love forever. More importantly, we ensure you
        enjoy and cherish every second of your magical day. Frame your life with
        us.
      </p>
      <div
        className={cls(
          "pl-[20px] pr-[20px] mt-[40px] mb-[40px] flex flex-col gap-[30px]",
          "xl:pl-[200px] xl:pr-[200px] xl:mt-[80px] xl:mb-[60px] xl:flex xl:flex-row xl:gap-[100px]"
        )}
      >
        <div className="flex flex-col xl:w-[400px] gap-[20px] ">
          <div className="flex flex-col text-left ">
            <p
              className={cls(
                "font-[Headings] font-extrabold text-[25px]",
                "xl:text-[35px] "
              )}
            >
              A NEW WAY OF
            </p>
            <p
              className={cls(
                "font-[Headings] font-extrabold text-[25px] ",
                "xl:text-[35px]"
              )}
            >
              CREATING MEMORIES.
            </p>
          </div>

          <div className="flex flex-col text-left  text-[14px] font-[description1] text-[#7d7c7c] xl:text-left ">
            <p>
              Where every moment is captured with creativity and heart, turning
              your wedding day into an unforgettable story.Crafting timeless
              stories with fresh perspectives and innovative techniques, so your
              special day lives on forever.
            </p>
            <p>
              Blending tradition with modern artistry to create wedding memories
              as unique as your love story.
            </p>
          </div>

          <Link to="/connect">
            {" "}
            <button
              className={cls(
                "p-[15px] text-[14px] font-[description1] border-black border-[0.8px] w-[150px]"
              )}
            >
              Contact Us
            </button>
          </Link>
        </div>

        <div className={cls("flex flex-col gap-[5px]", "xl:flex xl:flex-row")}>
          <img
            src={a2}
            className={cls(
              "w-full h-[500px] object-cover",
              "xl:w-[250px] xl:h-[300px]"
            )}
          />
          <img
            src={a1}
            className={cls(
              "w-full h-[500px] object-cover",
              "xl:w-[250px] xl:h-[350px] xl:mt-[40px]"
            )}
          />
          <img
            src={a3}
            className={cls(
              "w-full h-[500px] object-cover",
              "xl:w-[250px] xl:h-[300px]"
            )}
          />
        </div>
      </div>
      <div className={cls("flex flex-col gap-[20px] mb-[40px]")}>
        <p
          className={cls(
            "text-center font-[Headings] font-extrabold text-[25px] pl-[20px] pr-[20px]",
            "xl:text-[35px] xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          THE ORIGIN
        </p>

        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          Stories by RG was founded in 2009 by Praveen, a passionate
          photographer who transformed his love for the craft into a thriving
          profession. The name Stories by RG is a tribute to his teachers, Ramu
          and Geetha, whose guidance and wisdom inspired him to pursue this
          path. 
        </p>
        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          Over the years, Stories by RG has grown into a $50+ million industry,
          known for delivering exceptional products and services. Our ultimate
          aim is to create employment opportunities while capturing the
          beautiful moments that make every wedding unique.
        </p>
      </div>

      <div className={cls("flex flex-col gap-[20px] mb-[40px]")}>
        <p
          className={cls(
            "text-center font-[Headings] font-extrabold text-[25px] pl-[20px] pr-[20px]",
            "xl:text-[35px] xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          THE VISION
        </p>

        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          At Stories by RG, our vision is to create a legacy and make a profound
          impact in the wedding photography industry. Our ultimate goal is to
          establish a seamlessly organized wedding photography company that
          serves clients across India.
        </p>
        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          We strive to deliver unique, creative, and personalized wedding
          stories. We aim to be an integral part of our clients' special days
          and treat them as family, not just customers. We create a comfortable
          environment for our clients to make the best memories. By continually
          innovating, we become a cherished part of couples' big day
          celebrations.
        </p>

        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          Capture not just images, but the emotions and happiness of each
          moment. Provide a modern approach to an age-old tradition. Stay true
          to our roots and basics while continuously updating ourselves with the
          latest technologies and advancements.
        </p>
      </div>

      <div className={cls("flex flex-col gap-[20px] mb-[40px]")}>
        <p
          className={cls(
            "text-center font-[Headings] font-extrabold text-[25px] pl-[20px] pr-[20px]",
            "xl:text-[35px] xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          THE TEAM
        </p>

        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          Our team at Stories by RG consists of 150 highly talented and skillful
          members. We have 10 specialized departments, including SLS, CRM, photo
          editing, and video editing. Our team is dedicated to creating wonders,
          exploring new ideas, and staying updated with the latest trends and
          technologies.
        </p>
        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          Our in-house photographers, editors, and album designers are
          exceptionally skillful and talented, ensuring that every project we
          undertake is crafted to perfection.
        </p>
      </div>

      <div className={cls("flex flex-col gap-[20px] mb-[40px]")}>
        <p
          className={cls(
            "text-center font-[Headings] font-extrabold text-[25px] pl-[20px] pr-[20px]",
            "xl:text-[35px] xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          THE SERVICES
        </p>

        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          At Stories by RG, we offer a comprehensive range of services to ensure
          your wedding memories are captured beautifully and preserved for a
          lifetime.
        </p>
        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          Our services include the best 4K ultra videos, cinematic films, and
          teasers, as well as high-quality video albums. We specialize in
          creating extremely innovative photos in candid, portrait, and
          traditional styles, and provide premium albums and photo magazines to
          showcase your memories. Each client also receives AI-enhanced photos
          for a unique touch and complimentary Thaalagiri albums to add an
          extra-special touch. We treat every wedding as a personalized
          experience, ensuring everlasting memories.
        </p>

        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          Additionally, we offer conceptual pre-wedding and destination
          pre-wedding shoots to capture the excitement leading up to your big
          day.
        </p>
      </div>

      <div className={cls("flex flex-col gap-[20px] mb-[40px]")}>
        <p
          className={cls(
            "text-center font-[Headings] font-extrabold text-[25px] pl-[20px] pr-[20px]",
            "xl:text-[35px] xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          THE ACHIEVEMENTS
        </p>

        <p
          className={cls(
            " text-[14px] font-[description1] text-[#7d7c7c] pl-[20px] pr-[20px] text-center",
            "xl:pl-[380px] xl:pr-[380px]"
          )}
        >
          At Stories by RG, we take pride in our notable achievements. We have
          been featured in many prestigious magazines, including the Times of
          India and Wedding Wire, establishing our reputation as premium wedding
          photographers. Our rapid rise to fame is a testament to our dedication
          and exceptional service. We have expanded our presence with two
          branches in Bangalore and Hyderabad, and our portfolio includes
          high-profile celebrity weddings.
        </p>
      </div>
    </>
  );
}
